module.exports = __webpack_public_path__ + "img/skimmer_driving.ea82db1e.svg";